﻿import { Router } from './router';
import { Tracker } from './tracker';
import { ContactManager } from './contact';
import { I18nManager } from './i18n';
import { SettingsManager } from './settings'; // Importamos el nuevo manager

document.addEventListener('DOMContentLoaded', () => {
    console.log('🚀 ROMI Showroom: Inicializando...');

    // Inicializamos todos los módulos
    new SettingsManager();
    const router = new Router();
    new Tracker();
    new ContactManager();
    const i18n = new I18nManager();

    // Conectar el selector de idioma del nuevo panel con el motor i18n
    const langSelect = document.getElementById('lang-select') as HTMLSelectElement;
    if (langSelect) {
        // Cargar el idioma guardado al iniciar
        langSelect.value = i18n.currentLang;
        // Escuchar cambios
        langSelect.addEventListener('change', (e) => {
            const newLang = (e.target as HTMLSelectElement).value;
            i18n.setLanguage(newLang);
        });
    }
});